import { SearchableCombobox, TSearchable } from '@/components/base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { AccommodationRoomTypeTypes } from '@/types'
interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

interface RoomTypeTaskFieldItem {
  id: AccommodationRoomTypeTypes
  name: string
}

const values: RoomTypeTaskFieldItem[] = [
  { id: AccommodationRoomTypeTypes.Single, name: 'Single' },
  { id: AccommodationRoomTypeTypes.Double, name: 'Double' },
  { id: AccommodationRoomTypeTypes.Twin, name: 'Twin' },
  { id: AccommodationRoomTypeTypes.Other, name: 'Other' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<RoomTypeTaskFieldItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => { }}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
